module.exports = __webpack_public_path__ + "static/media/signage-indoor-img73.0babe8b2.jpg";